import { AllSortMethods } from '@/common/utils/AllSortMethods';

export const getFiltersFromPath = ({ pathname, aggregations, allCategories, sortFields }) => {
  const filters = new Map();

  const pathArr = pathname.split('/');

  // 过滤掉分页参数
  const findIndex = pathArr.indexOf('p');

  if (findIndex > -1 && /^\d+$/.test(pathArr[findIndex + 1])) {
    pathArr.splice(findIndex, 2);
  }

  // 过滤掉排序，目录
  const filteredPathArr = pathArr.filter(temp => {
    return (
      temp !== '' &&
      allCategories.findIndex(item => item.url_key === temp + '/') === -1 &&
      sortFields.findIndex(item => item.value === temp) === -1
    );
  });

  const layer_filter_items = [];

  filteredPathArr.forEach((subPath, index) => {
    if (filteredPathArr[index - 1] && filteredPathArr[index - 1] === 'size') {
      const group = 'lw_size';

      // size 需要特殊处理
      if (subPath.indexOf(',') > -1) {
        const sizeArr = subPath.split(',');

        const items = new Set();

        sizeArr.forEach(size => {
          const findAggregation = aggregations.find(temp => temp.rewrite === size);

          if (findAggregation) {
            items.add(findAggregation.option_id);
          }
        });

        filters.set(group, items);
      } else {
        const findAggregation = aggregations.find(temp => temp.rewrite === subPath);

        const items = new Set();

        if (findAggregation) {
          items.add(findAggregation.option_id);
          filters.set(group, items);
        }
      }
    } else if (filteredPathArr[index - 1] && filteredPathArr[index - 1] === 'color') {
      const group = 'lw_color';

      // color 需要特殊处理

      if (subPath.indexOf(',') > -1 || subPath.indexOf('%2C') > -1) {
        const sizeArr = subPath.split('%2C');

        const items = new Set();

        sizeArr.forEach(size => {
          const findAggregation = aggregations.find(temp => temp.rewrite === size);

          if (findAggregation) {
            items.add(findAggregation.option_id);
          }

          layer_filter_items.push(findAggregation?.rewrite);
        });

        filters.set(group, items);
      } else {
        const findAggregation = aggregations.find(temp => temp.rewrite === subPath);

        const items = new Set();

        if (findAggregation) {
          items.add(findAggregation.option_id);
          filters.set(group, items);
        }

        layer_filter_items.push(findAggregation?.rewrite);
      }
    } else {
      const findAggregation = aggregations.find(temp => temp.rewrite === subPath);

      let group;
      const items = new Set();

      if (findAggregation) {
        group = findAggregation.code;
        items.add(findAggregation.option_id);
        filters.set(group, items);
      } else if (/^\d+\-\d+$/g.test(subPath)) {
        group = 'price';
        items.add({
          title: subPath.replace('-', '_'),
          value: subPath.replace('-', '_'),
        });
        filters.set(group, items);
      }
    }
  });

  return {
    filters,
    layer_filter_items,
  };
};

export const getPageFromPath = pathname => {
  const pathArr = pathname.split('/');

  const findIndex = pathArr.indexOf('p');

  if (findIndex > -1 && /^\d+$/.test(pathArr[findIndex + 1])) {
    return pathArr[findIndex + 1];
  }

  return 1;
};

export const getSortFromSearchParams = (searchParams, useMap = true) => {
  const sortQuery = useMap ? searchParams.get('sort_by') : searchParams['sort_by'];

  const findSort = AllSortMethods.find(temp => temp.sortQuery === sortQuery);

  const sortState = findSort || {
    sortId: 'sortItem.created_at',
    sortText: 'New Arrivals',
    sortAttribute: 'created_at',
    sortDirection: 'DESC',
    sortQuery: 'new',
    // sortId: "sortItem.position",
    // sortText: "Featured",
    // sortAttribute: "position",
    // sortDirection: "ASC",
    // sortQuery: "featured",
  };

  return sortState;
};

export const getSortMethodFromValue = value => {
  return AllSortMethods.find(temp => temp.sortQuery === value || temp.sortAttribute === value);
};

export const getSortByFromSearchParams = (searchParams, useMap = true) => {
  const sortBy = useMap ? searchParams.get('sort_by') : searchParams['sort_by'];

  return sortBy;
};

export const getStockFromSearchParams = (searchParams, useMap = true) => {
  let stockStatus = useMap ? searchParams.get('stock') : searchParams['stock'];

  if (stockStatus === null || stockStatus === undefined) {
    return 1;
  }
  if (stockStatus === 0 || stockStatus === '0') {
    return 0;
  }
  if (stockStatus === 1 || stockStatus === '1') {
    return 1;
  }
  return 1;
};
